import {
  base_colorAction,
  base_colorAlert,
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  base_contentSelected,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InvoiceUploader {
    display: flex;
    flex-direction: column;
    gap: ${spacing(3)};
  }

  .uploader-dropzone {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spacing(1)};
    padding: ${spacing(6)} ${spacing(4)};
    border: 1px dashed ${base_colorContentBorder};
    border-radius: ${cornerRadius};
    background-color: ${base_colorSurfaceSecondary};
    cursor: pointer;
    text-align: center;
    ${font_sm};
    color: ${text_colorTextSecondary};

    transition: background-color 100ms ease-out;

    &:hover,
    &.is-drag-active {
      border-color: ${base_colorAction};
      background-color: ${base_contentSelected};
    }

    &.is-error {
      border-color: ${base_colorAlert};
    }
  }

  .uploader-cta {
    ${font_md};
    color: ${text_colorTextSecondary};
  }

  .uploader-link {
    font-family: ${font_family_weight_medium};
    color: ${base_colorAction};
  }

  .uploader-hint {
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .uploader-file {
    display: flex;
    align-items: center;
    gap: ${spacing(3)};
    padding: ${spacing(3)} ${spacing(4)};
    border: 1px solid ${base_colorContentBorder};
    border-radius: ${cornerRadius};
    background-color: ${base_colorSurfaceSecondary};
  }

  .uploader-file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .uploader-file-meta {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    overflow: hidden;
    flex: 1;
    min-width: 0;
  }

  .uploader-file-name {
    ${font_md};
    color: ${text_colorTextPrimary};
  }

  .uploader-file-status {
    ${font_sm};
    color: ${text_colorTextSecondary};
  }

  .ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /* Trash affordance is hover/focus-revealed, but stays focusable and operable
     for keyboard users (opacity, not display, so the tab stop survives). */
  .uploader-file-remove {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: ${spacing(1)};
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: ${cornerRadius};
    opacity: 0;
    transition: opacity 100ms ease-out;

    &:focus-visible {
      opacity: 1;
      outline: 2px solid ${base_colorAction};
      outline-offset: 1px;
    }
  }

  .uploader-file:hover .uploader-file-remove,
  .uploader-file:focus-within .uploader-file-remove {
    opacity: 1;
  }

  .uploader-error {
    ${font_sm};
    color: ${base_colorAlert};
    margin: 0;
  }
`
